import {
  LISTA_NOTICIAS,
  LISTA_NOTICIAS_SUCESSO,
  LISTA_NOTICIAS_ERRO,
  CRIA_NOTICIA,
  CRIA_NOTICIA_SUCESSO,
  EDITA_NOTICIA,
  EDITA_NOTICIA_SUCESSO,
  DELETA_NOTICIA,
  DELETA_NOTICIA_SUCESSO,
  TOGGLE_ATIVO_NOTICIA,
  TOGGLE_ATIVO_NOTICIA_SUCESSO,
  NOTICIAS_ERRO,
} from 'constants/ActionTypes';

export const listaNoticias = (pagina = 1, tamanhoPagina = 20, busca = '') => ({
  type: LISTA_NOTICIAS,
  payload: { pagina, tamanhoPagina, busca },
});

export const listaNoticiasSucesso = (data) => ({
  type: LISTA_NOTICIAS_SUCESSO,
  payload: data,
});

export const listaNoticiasErro = (mensagem) => ({
  type: LISTA_NOTICIAS_ERRO,
  payload: mensagem,
});

export const criaNoticia = (formData) => ({
  type: CRIA_NOTICIA,
  payload: formData,
});

export const criaNoticiaSucesso = () => ({
  type: CRIA_NOTICIA_SUCESSO,
});

export const editaNoticia = (id, formData) => ({
  type: EDITA_NOTICIA,
  payload: { id, formData },
});

export const editaNoticiaSucesso = () => ({
  type: EDITA_NOTICIA_SUCESSO,
});

export const deletaNoticia = (id) => ({
  type: DELETA_NOTICIA,
  payload: { id },
});

export const deletaNoticiaSucesso = () => ({
  type: DELETA_NOTICIA_SUCESSO,
});

export const toggleAtivoNoticia = (id) => ({
  type: TOGGLE_ATIVO_NOTICIA,
  payload: { id },
});

export const toggleAtivoNoticiaSucesso = () => ({
  type: TOGGLE_ATIVO_NOTICIA_SUCESSO,
});

export const noticiasErro = (mensagem) => ({
  type: NOTICIAS_ERRO,
  payload: mensagem,
});
